import type {ColumnsSelectorDescriptor} from './columns-selector-control.types';

export const columnsSelectorDescriptor: ColumnsSelectorDescriptor = {
  previewIdFixedList: [2, 8, 11],
  initialSelectedId: 1,
};
